import collectionApiClient, {
  CountryPerformance,
  OrderGraphPeriod,
} from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useAllCollectionsCountryPerformanceQuery = (
  period: OrderGraphPeriod = OrderGraphPeriod.WEEK,
) => {
  return useKlydoQuery<CountryPerformance[]>({
    queryKey: ['allCollectionsCountryPerformance', period],
    queryFn: () =>
      collectionApiClient.getAllCollectionsCountryPerformance(period),
  });
};

export default useAllCollectionsCountryPerformanceQuery;
